import React, { Component } from 'react';
import Exclamation from './../../../../assets/img/exclamation.png';
import JobsOperationsApiHandler from './../../JobsOperationsApiHandler.js';
import CircularProgress from '@material-ui/core/CircularProgress';


export default class JobToShow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showLoader: false
		};
		this.jobDetails = this.jobDetails.bind(this);
	}

	jobDetails() {
		var job = this.props.job;
		if(job) {
			this.setState({showLoader: true});
			var operationType = this.props.operationType;
			JobsOperationsApiHandler.getJobsForJpinAndProcessType(job.jpin, operationType)
				.then(function(resp) {
					this.props.jobDetails(resp);
				}.bind(this)).catch(function(error) {
					
				})
		}
	}

	render() {
		var job = this.props.job;
		var locations = job.inwardingLocations.map((loc, index) => {return (<div style={{marginBottom:'8px'}} key={index}>{loc}</div>)})
		var assignees = job.assigneeNameAndPhone.map((asg, index) => {return (<div style={{marginBottom:'8px'}} key={index}>{asg}</div>)})
		return(
			<div className="top-thirty">
				<div className="putaway-product">
					<div className="row">
						<div className="col-xs-6 col-sm-2 col-md-2 centralized">
							<img src={job.imageUrls[0]} style={{maxWidth: '100%', maxHeight: '100px'}} alt="product"/>
						</div>
						<div className="col-sm-10 col-md-10">
							<div className="row">
								<div className="col-xs-6 col-md-12" style={{fontSize:'16px', color:'#212121', lineHeight:'22px'}}>
									{job.productTitle} <span className="pull-right hidden-xs" style={{fontSize:'13px',color:'#a3a3a3'}}>{job.status}</span>
								</div>
							</div>
							<div className="row putaway-product-label" style={{marginTop:'15px'}}>
								<div className="col-xs-3 col-sm-3 col-md-2">
									Inwarded Quantity
								</div>
								<div className="col-xs-4 col-sm-5 col-md-5">
									Inward Location
								</div>
								<div className="col-xs-5 col-sm-4 col-md-5">
									Assigned for Putaway
								</div>
							</div>
							<div className="row putaway-product-value" style={{marginTop:'8px'}}>
								<div className="col-xs-3 col-sm-3 col-md-2">
									{job.qty}
								</div>
								<div className="col-xs-4 col-sm-5 col-md-5">
									{locations}
								</div>
								<div className="col-xs-5 col-sm-4 col-md-5">
									{assignees}
								</div>
							</div>
							<div className="row">
								<div className="col-md-12">
									<button className="btn btn-more-details pull-right" onClick={this.jobDetails}>
										More Details 
										{(!this.state.showLoader)?
											<img src={Exclamation} alt="exc" style={{height:'20px',marginTop:'-3px'}}/>
											:
											<div style={{lineHeight:'17px',float:'right'}}>
											<CircularProgress size={12} thickness={5} style={{color:'#fff',marginTop:'5px', marginLeft:'5px'}} />
											</div>
										}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/JobToShow.js